module.exports = __webpack_public_path__ + "static/img/img-01.091148f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img-01.png
// module id = 65LY
// module chunks = 1